import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.LC + (config.isProd ? '/b2/ali-personal-service/box/api/' : '/b2/personal-service/box/api/')
const getTopicUrl = baseUrl + 'getActiveTopicTypeByGroupId/'
const postSuggestionUrl = baseUrl + 'postSuggestion'

Axios.defaults.headers.timeout = 8000

export default {

  getTopicByGroupId (groupId, cb) {
    Axios.get(getTopicUrl + groupId)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  postSuggestion (form, cb) {
    Axios.post(postSuggestionUrl, form).then(
      response => {
        cb(response)
      }
    ).catch(error => {
      console.log(error)
      cb(error.response)
    })
  }

}
